import { Component, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import { IconCardConfig, IconCardButtonClickResponse } from './icon-card';
import { visibilityFadeTrigger } from '../../core/pure-utils/animations';

@Component({
    selector: 'app-icon-card',
    templateUrl: 'icon-card.component.html',
    styleUrls: ['icon-card.component.scss'],
    animations: [
        visibilityFadeTrigger
    ],
    standalone: false
})
export class IconCardComponent {
  private _config = <IconCardConfig> {};
  @Input()
  get config(): IconCardConfig { return this._config; }
  set config(value: IconCardConfig) {
    this._config = value;
    this.fav = value.toggleSwitch?.state ?? false;
  }

  @Output() readonly buttonClick = new EventEmitter<IconCardButtonClickResponse>();
  @Output() readonly favChange = new EventEmitter<boolean>();

  constructor(private changeDetectorRef: ChangeDetectorRef) { }

  fav = false;

  onButtonClick(buttonClickResponse: IconCardButtonClickResponse) {
    this.buttonClick.emit(buttonClickResponse);
  }

  onFavClick() {
    this.fav = !this.fav;
    this.favChange.emit(this.fav);
  }
}
